
<mat-select [(ngModel)]="parseValue" [required]="required" [formControl]="formController" (ngModelChange)="valueUpdated()" style="min-width:150px;" [class]="className" disabled="{{disabled}}" multiple="multiple">
  <mat-option *ngFor="let option of options;" [value]="option.value" [disabled]="option.disabled">{{option.display}}</mat-option>
</mat-select>